<template>
  <div class="container">
    <div class="operation">
      <div class="btns">
        <el-button type="primary" size="mini" @click="$refs.dialog.open()">新增商品系列</el-button>
      </div>
      <div class="search">
        <div>
          <div class="demo-input-suffix">
            店铺名:
            <el-input v-model="input" class="searchInput" size="mini" placeholder="请输入店铺名"></el-input>
          </div>
          <div class="demo-input-suffix">
            内容:
            <el-input v-model="input" class="searchInput" size="mini" placeholder="请输入搜索内容"></el-input>
          </div>
          <el-button size="mini" type="primary">查询</el-button>
        </div>
      </div>
    </div>
    <div class="itemNav">
      <span>
        <el-checkbox v-model="allChecked"></el-checkbox>
      </span>
      <span>序号</span>
      <span>商品系列图片</span>
      <span>商品系列名称</span>
      <span>关联店铺</span>
      <span>创建时间</span>
    </div>
    <div class="item" v-for="(item,index) in 12" :key="index">
      <span>
        <el-checkbox v-model="allChecked"></el-checkbox>
      </span>
      <span>{{ index+1 }}</span>
      <span>
        <img
          src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1588927627793&di=e226d4011f62af3b348a9423c7b06843&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201708%2F29%2F20170829182932_NxVad.thumb.700_0.jpeg"
          alt
        />
      </span>
      <span>七匹狼（SEPTWOLVES）男鞋休闲鞋</span>
      <span>店铺1</span>
      <span>2019-09-23 13: 42</span>
    </div>
    <!-- 分页 -->
    <div class="pag">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="30"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="20"
      ></el-pagination>
    </div>
    <!-- 新增系列产品 -->
    <dialog-addseries ref="dialog" :singleImg="true"></dialog-addseries>
  </div>
</template>

<script>
import { shopcategoryAdd } from "../../../service";
import uploadImg from "../../../components/uploadImg";
import dialogAddseries from "../../../components/dialogAddseries"
export default {
  data() {
    return {
      input: "",
      allChecked: false,
      seriesTitle: "",
      form: {},
    };
  },
  methods: {
    getShopcategoryAdd() {
      this.$refs.uploadImgs.$emit("bridge", true);
    },
    // 确定新增系列产品后，等图片上传成功之后，子组件再调用父组件方法
    fatherMethod(pic) {
      let params = {
        name: this.seriesTitle,
        pic
      };
      shopcategoryAdd(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "提交成功",
            type: "success"
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  },
  components: {
    uploadImg,
    dialogAddseries
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  padding: 0 20px;
  padding-right: 10px;
  border: none;
  box-sizing: border-box;
  .operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .search {
    display: flex;
    align-items: center;
    > div:first-child {
      display: flex;
      align-items: center;
    }
    .searchInput {
      width: 180px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      border-radius: 0;
      padding-left: 10px;
      margin-right: 20px;
    }
    .searchBtn {
      height: 38px;
      background: rgba(0, 119, 255, 1);
      border-radius: 0px 3px 3px 0px;
    }
  }
  .total {
    width: 121px;
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 12px;
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 6%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 20%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 28%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 22%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 20%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 68px;
    padding: 0px;
    padding-left: 18px;
    &:hover {
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(3) {
      img {
        width: 50px;
        height: 50px;
      }
    }
    span:nth-child(4) {
      color: #333;
    }
    span:nth-child(6) {
      color: #333333;
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
.addSeries {
  > h2 {
    height: 16px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 16px;
  }
  > .title {
    > h4 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 20px;
      margin-bottom: 6px;
    }
    > .seriesTitle {
      width: 34%;
    }
  }
  > .upload {
    margin-bottom: 30px;
    h4 {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 20px;
      margin-top: 16px;
      margin-bottom: 6px;
    }
  }
  .btns {
    text-align: center;
  }
}
</style>